export const blockIconsEditorEditNote = (
	<span className='material-symbols-outlined'>edit_note</span>
);
